<script setup lang="ts">
import { ElIcon } from 'element-plus'

import InfoIcon from '../../assets/icons/info.svg?component'
import type { TypographyVariants } from '../types/ui'

import BoxComponent from './BoxComponent.vue'
import FlexComponent from './FlexComponent.vue'
import TypographyComponent from './TypographyComponent.vue'

withDefaults(defineProps<{ variant?: TypographyVariants }>(), {
  variant: 'body-large',
})
</script>

<template>
  <BoxComponent class="container" :p="16">
    <FlexComponent :gap="16">
      <ElIcon :size="24">
        <InfoIcon />
      </ElIcon>
      <TypographyComponent :variant="variant"><slot /></TypographyComponent>
    </FlexComponent>
  </BoxComponent>
</template>

<style scoped lang="scss">
.container {
  border-radius: 16px;
  background: var(--button-hover);
}
</style>
